export default __webpack_public_path__ + "static/media/image3.140cec7d.png";